export const S3_COMPATIBLE_REPOSITORY_TYPE = {
  OVH: "ovh",
  SYSELEVEN: "syseleven"
};
export const STORAGE_REPOSITORY_TYPE = {
  GCS: "gcs",
  S3: "s3",
  FS: "fs",
  HDFS: "hdfs",
  ABS: "azure",
  ...S3_COMPATIBLE_REPOSITORY_TYPE
};
export const STORAGE_REPOSITORY_TYPE_LABELS = {
  s3: "Amazon S3",
  gcs: "Google Cloud Storage",
  fs: "File System",
  hdfs: "Hadoop Distributed File System",
  azure: "Azure Blob Storage",
  ovh: "OVH Object Storage",
  syseleven: "SysEleven Object Storage"
};
export const resolveRepositoryType = (type) => type === S3_COMPATIBLE_REPOSITORY_TYPE.OVH || type === S3_COMPATIBLE_REPOSITORY_TYPE.SYSELEVEN ? STORAGE_REPOSITORY_TYPE.S3 : type;
export const S3_AUTH_MODE = {
  AUTOMATIC: "automatic",
  KEY_SECRET: "key_secret"
};
export const GCS_AUTH_MODE = {
  AUTOMATIC: "automatic",
  SERVICE_ACCOUNT_KEY: "service_account_key"
};
export const AZURE_AUTH_MODE = {
  AUTOMATIC: "automatic",
  ACCOUNT_KEY: "account_key"
};
